import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../context/ThemeContext";
import UserContext from "../../../../context/UserContext";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from "primereact/inputtextarea";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12( $followId: Int) {
    tbl_trip_raport(
      where: {
        id_seq: { _eq: $followId}
       
      }
    ) {
   id_seq
   ust_id_seq
   date
   trip_date
   dealer
   notes
   notes_2
   result
   status
   

     
    }
  }
`;


const GET_RCLASS = gql`
  query MyQuery($drctype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drctype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_MAIN_DPR_M = gql`
  query MyQuery($type: String!, $firmSubCode: String) {
    tbl_user_detail(
      where: {
        user_lang: { _eq: $type },
       
       
      }
    ) {
      user_name
      name
     
    }
  }
`;




const UPDATE_FIRM = gql`
mutation UpdateRoomClass(
  $nextDate: date 
  $endDate: date 
  $firmType: String
  $dealer: String
  $conNotes: String
  $conoffers: String
  $callId: Int!
  $cusId: Int!

) {
  update_tbl_trip_raport(
    where: {
      id_seq: { _eq: $callId },
      ust_id_seq: { _eq: $cusId }
      
        

    },
    _set: { 
            trip_date: $nextDate,
            date: $endDate,
            status: $firmType,
            dealer: $dealer,
            notes: $conNotes,
            notes_2: $conoffers,
           }
  ) {
    affected_rows
  }
}
`;

const INSERT_RCLASS = gql`
  mutation InsertRoomClass(
    
    $nextDate: date
    $endDate: date
    $firmType: String
    $dealer: String
    $conNotes: String
    $conoffers: String
    $callId: Int!
    $cusId: Int!
    
    
  ) {
    insert_tbl_trip_raport(
      objects: {
       
            date: $endDate,
            trip_date: $nextDate,
            status: $firmType,
            dealer: $dealer,
            notes: $conNotes,
            notes_2: $conoffers,
            id_seq: $callId,
            ust_id_seq: $cusId
        
        
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;









const CusTripEdit = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext);
  const { varCode8, setVarCode8 } = useContext(ThemeContext);
  const { varCode4, setVarCode4 } = useContext(ThemeContext);
  const { varCode10, setVarCode10 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: {  followId: varCode8 },
  });
  const [UpdateRoomClass] = useMutation(UPDATE_FIRM);
  const [InsertRoomClass] = useMutation(INSERT_RCLASS);

  const firmData = data && data.tbl_trip_raport ? data.tbl_trip_raport[0] : null;

  const { loading: drcLoading, error: drcError, data: drcData } = useQuery(GET_RCLASS, {
    variables: { drctype: "TRIP", lang: "en" },
  });

  const { loading: dprmmLoading, error: dprmmError, data: dprmmData } = useQuery(GET_MAIN_DPR_M, {
    variables: { type: "en"},
  });

  const roomClassSelectItems = drcData && drcData.tbl_gnl_def
  ? drcData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const souDealerItems = dprmmData && dprmmData.tbl_user_detail
  ? dprmmData.tbl_user_detail.map(item => ({
    label: item.user_name,
    value: item.user_name,
    name: item.user_name,
    }))
  : [];


  
  const [active, setActive] = useState(firmData ? firmData.active : true);
  

  const [place, setPlace] = useState(firmData ? firmData.place : "");

  const [callId, setCallId] = useState(firmData ? firmData.id_seq : "");
  const [cusId, setCusId] = useState(firmData ? firmData.ust_id_seq : varCode4);
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.date) : new Date());
  const [nextDate, setNextDate] = useState(firmData ? new Date(firmData.trip_date) : new Date());
  const [firmType, setFirmType] = useState(firmData ? firmData.status : "");  
  const [dealer, setDealer] = useState(firmData ? firmData.dealer : varCode10);  
  const [conNotes, setConNotes] = useState(firmData ? firmData.notes : "");  
  const [conoffers, setConOffers] = useState(firmData ? firmData.notes_2 : ""); 
  const [conResult, setConResult] = useState(firmData ? firmData.result : ""); 
  console.log("Firm Data:", firmData);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.userDprSub;

  const [isDisabled, setIsDisabled] = useState(false);


  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const close_form = messages[currentLocale].close_form;
  const new_firm = messages[currentLocale].new_firm;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const typerec = messages[currentLocale].typerec;
  const placerec = messages[currentLocale].placerec;
  const time_zone = messages[currentLocale].time_zone;
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create_room_classrec = messages[currentLocale].create_room_classrec;
  const create_room_typerec = messages[currentLocale].create_room_typerec;
  const select_a_room_class = messages[currentLocale].select_a_room_class
  const create = messages[currentLocale].create;
  const update = messages[currentLocale].update;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const definitions = messages[currentLocale].definitions;
  const managing_hotel = messages[currentLocale].managing_hotel;
  const firm_detail = messages[currentLocale].firm_detail;
  const agency_detail = messages[currentLocale].agency_detail;
  const sub_agency_detail = messages[currentLocale].sub_agency_detail;
  const sub_hotel_detail = messages[currentLocale].sub_hotel_detail;
  const main_department_tab = messages[currentLocale].main_department_tab;
  const sub_department_tab = messages[currentLocale].sub_department_tab;
  const rulesrec = messages[currentLocale].rulesrec;
  const account_cart_tab = messages[currentLocale].account_cart_tab;
  const bank_accounts_tab = messages[currentLocale].bank_accounts_tab;
  const room_class_tab = messages[currentLocale].room_class_tab;
  const room_type_tab = messages[currentLocale].room_type_tab;
  const room_class_code = messages[currentLocale].room_class_code;
  const room_class_name = messages[currentLocale].room_class_name;
  const room_type_code = messages[currentLocale].room_type_code;
  const room_type_name = messages[currentLocale].room_type_name;
  const room_bed_title = messages[currentLocale].room_bed_title;
  const room_bed_type_title = messages[currentLocale].room_bed_type_title;
  const room_total_title = messages[currentLocale].room_total_title;
  const room_max_pax_title = messages[currentLocale].room_max_pax_title;
  const room_min_pax_title = messages[currentLocale].room_min_pax_title;
  const room_chl_max_title = messages[currentLocale].room_chl_max_title;
  const room_chl_min_title = messages[currentLocale].room_chl_min_title;
  const room_baby_start_title = messages[currentLocale].room_baby_start_title;
  const room_baby_end_title = messages[currentLocale].room_baby_end_title;
  const room_chl_start_title = messages[currentLocale].room_chl_start_title;
  const room_chl_end_title = messages[currentLocale].room_chl_end_title;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_name = messages[currentLocale].sub_department_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const dpr_update_successfully = messages[currentLocale].dpr_update_successfully;

  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;

  const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.id_seq :"");
  const [contIdSeqq, setContIdSeqq] = useState(0);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 



  useEffect(() => {
    if (firmData) {
      setCallId(firmData.id_seq);
      setCusId(firmData.ust_id_seq);
      setEndDate(new Date(firmData.date));
      setNextDate(new Date(firmData.trip_date));
      setFirmType(firmData.status);
      setDealer(firmData.dealer);
      setConNotes(firmData.notes);
      setConOffers(firmData.notes_2);
      setConResult(firmData.result);
      

      
    }
  }, [firmData]);

  useEffect(() => {
    if (ownFirmSubType === 'USR') {
      
      setIsDisabled(true);
    }
  }, [ownFirmSubType]);


  const handleUpdateIdSeq = async () => {
    const requiredFields = [ 'dealer', 'firmType' ]; // Required fields
    const customFieldNames = {
      
      dealer: "Broker",
      firmType: "Contact Type"
    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'FOLLOW', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setContIdSeq(updatedIdSeq); 
        setCallId(updatedIdSeq); 
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      const emptyFieldsMessage = `Lütfen şu alanları doldurun: ${emptyFields.join(', ')}`;
      window.alert(emptyFieldsMessage);
    }
  };
  
  const validateForm = (requiredFields, customFieldNames) => {
    for (const field of requiredFields) {
      if (!eval(field)) {
        return false;
      }
    }
    return true;
  };
  
  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
    return emptyFields;
  };
  
  useEffect(() => {
    if (contIdSeq !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
      handleinsert(contIdSeq);  
    }
  }, [contIdSeq]);

  

  const handleUpdate = () => {
    const year = nextDate.getFullYear();
    const month = (nextDate.getMonth() + 1).toString().padStart(2, '0');
    const day = nextDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const year2 = endDate.getFullYear();
    const month2 = (endDate.getMonth() + 1).toString().padStart(2, '0');
    const day2 = endDate.getDate().toString().padStart(2, '0');
    const formattedDate2 = `${year2}-${month2}-${day2}`;
    UpdateRoomClass({
      variables: {
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        callId: callId,
        cusId: cusId,
        endDate: formattedDate2,
        nextDate: formattedDate, 
        firmType: firmType,
        dealer: dealer,
        conNotes: conNotes,
        conoffers: conoffers,


       
        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const handleinsert = () => {
    const year = nextDate.getFullYear();
    const month = (nextDate.getMonth() + 1).toString().padStart(2, '0');
    const day = nextDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const year2 = endDate.getFullYear();
    const month2 = (endDate.getMonth() + 1).toString().padStart(2, '0');
    const day2 = endDate.getDate().toString().padStart(2, '0');
    const formattedDate2 = `${year2}-${month2}-${day2}`;
    InsertRoomClass({
      variables: {
        callId: callId,
        cusId: cusId,   
        endDate: formattedDate2,
        nextDate: formattedDate, 
        firmType: firmType,
        dealer: dealer,
        conNotes: conNotes,
        conoffers: conoffers,
       
    
           
      },
    })
      .then(() => {
        window.alert("Firm insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;

return (
  <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    

    <div className="flex">
  <div className="mr-2 w-24" >
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"Call Id"}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={callId}
      onChange={(e) => setCallId(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
   />
  </div>

  <div className="mr-2 w-24" >
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"Cust Id"}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={cusId}
      onChange={(e) => setCusId(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
   />
  </div>

  <div className="w-1/5 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Record Date"}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      <div className="w-1/5 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Trip Date"}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={nextDate} dateFormat="dd/mm/yy"
        onChange={(e) => setNextDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      

  <div>
  <label htmlFor="roomClassDropdown" className="block font-medium ml-10 text-gray-700">
      {"Status"}
    </label>
  <Dropdown
  
    className="h-11 ml-10 w-52 rounded-md"
    
    style={{ flex: '2' }}
    value={firmType}
    options={roomClassSelectItems}
    onChange={(e) => setFirmType(e.value)}
    placeholder={"Select Type"}
  />
  </div>


  <div>
  <label htmlFor="roomClassDropdown" className="block font-medium ml-10 text-gray-700">
      {"Broker"}
    </label>
  <Dropdown
  
    className="h-11 ml-10 w-52 rounded-md"
    
    style={{ flex: '2' }}
    value={dealer}
    options={souDealerItems}
    onChange={(e) => setDealer(e.value)}
    placeholder={"Select Broker"}
    disabled={isDisabled}
  />
  </div>
  
</div>




    <div className="mt-4">
      <label htmlFor="firmName" className="block font-medium text-gray-700">
       {"Inspection Trip Notes"}
      </label>
      <InputTextarea
        type="text"
        id="firmName"
        name="firmName"
        value={conNotes}
        onChange={(e) => setConNotes(e.target.value)}
        className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      />
      
    </div>
    <div className="mt-4">
      <label htmlFor="firmName" className="block font-medium text-gray-700">
       {"Conversation Details"}
      </label>
      <InputTextarea
        type="text"
        id="firmName"
        name="firmName"
        value={conoffers}
        onChange={(e) => setConOffers(e.target.value)}
        className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      />
      
    </div>


    

    <div className="mt-4 flex justify-end">
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdate}
      >
        {"Update Save"}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateIdSeq}
      >
        {"New Raport Save"}
      </button>
    </div>
  </div>
);
};

export default CusTripEdit;
